import { useRouter } from 'next/router';
import { FormEvent, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';

import * as S from './styles';

interface SearchBarProps {
  sidebarVersion?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  sidebarVersion = false,
}) => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState('');

  const onSubmitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (searchValue.trim().length <= 0) {
      return;
    }

    router.push(`/central-de-ajuda/pesquisa?s=${searchValue}`);
    setSearchValue('');
  };

  return (
    <S.SearchBarContainer sidebarVersion={sidebarVersion}>
      <form onSubmit={onSubmitSearch}>
        <button type="submit" title="Pesquisar">
          <span>
            <IoSearchOutline size={sidebarVersion ? 18 : 24} />
          </span>
        </button>
        <input
          type="text"
          placeholder="Pesquisar"
          onChange={event => setSearchValue(event.target.value)}
          value={searchValue}
        />
      </form>
    </S.SearchBarContainer>
  );
};
